export default "/images/85f75da221202cab9147a54a94ba7c22.jpg";